import { IDocument } from '@models/Document.model';
import { getPermissionData } from '@utils';
import React from 'react';
import { MutationPatchDocument } from './Documents.types';

export function handleClick(
  favoritePermission: ReturnType<typeof getPermissionData>,
  mutationPatchDocument: MutationPatchDocument,
  item: IDocument,
): React.MouseEventHandler<HTMLButtonElement> {
  return () => {
    if (favoritePermission.allowed) {
      mutationPatchDocument.mutate({
        data: {
          documentId: item.id,
          favorite: item.favorite ? 'false' : 'true',
        },
      });
    }
  };
}

export function fixCannonUrl(doc: IDocument) {
  if (!doc.uri) return doc;
  const url = doc.uri;
  const isCanonDoc = url.indexOf('downloads.canon.com') > -1;
  const isHttps = url.startsWith('https://');
  if (isCanonDoc && isHttps) doc.uri = `http${url.slice(5)}`;
  return doc;
}
